import Vue from 'vue';
import Meta from 'vue-meta';
import Gtag from 'vue-gtag';
import VueCookies from 'vue-cookies';

import '@/core/style.css';
import store from '@/store';
import router from '@/core/router.js';
import i18n from '@/core/i18n.js';

import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';

import App from './App.vue';

Vue.use(Meta);
Vue.use(Gtag, { config: { id: process.env.GA_MEASUREMENT_ID } });
Vue.use(VueCookies);
Vue.$cookies.config('','','',true);

Vue.use(i18n);

Vue.component('v-select', vSelect);

import("@/utilities/firebase.js")
  .then(({ signInFirebase }) => signInFirebase())
  .then(() => console.log('signInFirebase Anonymously Success ~~~'))
  .catch(err => console.warn('signInFirebase Anonymously Failed !!', err));

// use user-agent to decide load Sentry or not
import('./utilities/sentry')
  .then(({ initSentry }) => {
    return initSentry({
      Vue,
      router,
      dsn: process.env.SENTRY_DSN,
    });
  })
  .then(() => console.log('Sentry init Success ~~~'))
  .catch(err => console.error('Sentry init Failed !!', err));

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#root');
